<template>
  <div>
    <div class="d-flex flex-wrap align-items-center justify-content-between gap-2 mb-2">
      <h6 class="mb-0">Логи в реальном времени</h6>
      <div class="d-flex align-items-center gap-2">
        <select :value="filter" class="form-select form-select-sm log-filter" @change="$emit('update:filter', $event.target.value)">
          <option value="all">Все</option>
          <option value="stdout">stdout</option>
          <option value="stderr">stderr</option>
          <option value="warning">предупреждения</option>
          <option value="error">ошибки</option>
          <option value="step">шаги</option>
        </select>
        <button class="btn btn-light border btn-sm" @click="$emit('copy')">Копировать логи</button>
        <button class="btn btn-light border btn-sm" @click="$emit('download')">Скачать TXT</button>
        <button class="btn btn-outline-secondary btn-sm" @click="$emit('clear')">Очистить</button>
      </div>
    </div>

    <div ref="consoleRef" class="log-console" @scroll="handleScroll">
      <div v-if="entries.length === 0" class="log-empty">Нет логов для отображения</div>
      <div v-for="entry in entries" :key="entry.key" class="log-line" :class="`log-${entry.kind}`">
        <span class="log-ts">[{{ formatTime(entry.timestamp) }}]</span>
        <span class="log-tag">{{ entry.kind.toUpperCase() }}</span>
        <span class="log-msg">{{ entry.message }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import { nextTick, ref, watch } from 'vue'

export default {
  name: 'WpDeploymentLogConsole',
  props: {
    entries: { type: Array, default: () => [] },
    filter: { type: String, default: 'all' },
  },
  emits: ['update:filter', 'copy', 'download', 'clear'],
  setup(props) {
    const consoleRef = ref(null)
    const canAutoscroll = ref(true)

    const handleScroll = () => {
      const el = consoleRef.value
      if (!el) return
      const offset = el.scrollHeight - (el.scrollTop + el.clientHeight)
      canAutoscroll.value = offset < 24
    }

    watch(
      () => props.entries.length,
      async () => {
        if (!canAutoscroll.value) return
        await nextTick()
        const el = consoleRef.value
        if (el) el.scrollTop = el.scrollHeight
      }
    )

    const formatTime = value => {
      const date = new Date(value)
      if (Number.isNaN(date.getTime())) return '-'
      return date.toLocaleTimeString()
    }

    return { consoleRef, handleScroll, formatTime }
  },
}
</script>

<style scoped>
.log-filter {
  width: 128px;
}

.log-console {
  height: 340px;
  overflow: auto;
  background: #0f172a;
  border-radius: 10px;
  border: 1px solid #1e293b;
  padding: 8px 10px;
}

.log-empty {
  color: #93a4c4;
  font-size: 12px;
}

.log-line {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, 'Liberation Mono', 'Courier New', monospace;
  font-size: 12px;
  line-height: 1.45;
  margin-bottom: 2px;
  white-space: pre-wrap;
  word-break: break-word;
}

.log-ts {
  color: #9fb0d3;
  margin-right: 8px;
}

.log-tag {
  font-weight: 700;
  margin-right: 8px;
}

.log-msg {
  color: #d6e0f5;
}

.log-step .log-tag,
.log-step .log-msg {
  color: #8fb5ff;
}

.log-warning .log-tag,
.log-warning .log-msg {
  color: #ffdd92;
}

.log-error .log-tag,
.log-error .log-msg,
.log-stderr .log-tag,
.log-stderr .log-msg {
  color: #ffb3b3;
}
</style>
